import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ITabGroupState {
  currentTab: string;
}

export const tabGroupInitialState: ITabGroupState = {
  currentTab: "",
};

export const TabGroupSlice = createSlice({
  name: "tabGroup",
  initialState: tabGroupInitialState,
  reducers: {
    updateCurrentTab: (state, action: PayloadAction<string>) => ({
      ...state,
      currentTab: action.payload,
    }),
    resetTab: (state) => ({ ...state, currentTab: "" }),
  },
});
export const { updateCurrentTab, resetTab } = TabGroupSlice.actions;
export const selectCurrentTab = (state: any) => state.tabGroup;
export default TabGroupSlice.reducer;
